import {
  patchVisualAssessment,
  Report,
} from "@/services/backend/htz/report/types/report";
import {
  ETable,
  ETableBody,
  ETableCell,
  ETableCellInput,
  ETableCellSelect,
  ETableHead,
  ETableHeader,
  ETableRow,
} from "@/shared/components/tables/e-table";
import t from "@/lang/lang";
import { AirHandlingUnitComponentName } from "@/services/backend/htz/ahu/components/air-handling-unit-data-designation";
import {
  updateHtzReportCache,
  PatchVisualAssessmentRequest,
  useHtzReportPatchVisualAssessmentMutation,
  useHtzReportShowQuery,
} from "@/services/backend/htz/report/api/report-api";
import { UUID } from "@bitory-gmbh/nidavellir";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import {
  Result,
  ResultItems,
} from "@/services/backend/htz/inspection/components/inspection-result";

export function VisualAssessmentsTable({ report }: { report: Report }) {
  const { data } = useHtzReportShowQuery({ id: report.id });

  if (!data) return;

  return (
    <ETable>
      <ETableHeader>
        <ETableRow>
          <ETableHead>{t("Komponente")}</ETableHead>
          <ETableHead>{t("Mangel")}</ETableHead>
          <ETableHead>{t("Handlungsempfehlung")}</ETableHead>
          <ETableHead>{t("Bemerkung")}</ETableHead>
          <ETableHead>{t("Ergebnis")}</ETableHead>
        </ETableRow>
      </ETableHeader>
      <ETableBody>
        {report.visualAssessments.map((assessment) => (
          <Row
            key={assessment.id}
            reportId={data.id}
            assessmentId={assessment.id}
          />
        ))}
      </ETableBody>
    </ETable>
  );
}

function Row({
  reportId,
  assessmentId,
}: {
  reportId: UUID;
  assessmentId: UUID;
}) {
  const { data } = useHtzReportShowQuery({ id: reportId });
  const request: PatchVisualAssessmentRequest = {
    id: reportId,
    assessmentId: assessmentId,
  };
  const [set] = useOptimisticDebouncedMutation(
    request,
    updateHtzReportCache,
    useHtzReportPatchVisualAssessmentMutation(),
  );

  const assessment = data?.visualAssessments.find((a) => a.id === assessmentId);

  if (!data || !assessment) return;

  return (
    <ETableRow key={assessment.id}>
      <ETableCell className="font-medium">
        <AirHandlingUnitComponentName
          id={data.ahuDataId!}
          componentId={assessment.componentId}
        />
      </ETableCell>
      <ETableCell>{assessment.deficiency}</ETableCell>
      <ETableCellInput
        value={assessment.recommendation}
        onChange={(e) => {
          const recommendation = e.target.value;
          set(
            { ...request, recommendation },
            patchVisualAssessment(data, { ...assessment, recommendation }),
          );
        }}
      />
      <ETableCell>{assessment.comment}</ETableCell>
      <ETableCellSelect
        value={assessment.result}
        onValueChange={(result) =>
          set(
            { ...request, result: result as Result },
            patchVisualAssessment(data, {
              ...assessment,
              result: result as Result,
            }),
          )
        }
        label={"Ergebnis"}
        items={ResultItems}
      />
    </ETableRow>
  );
}
